export default __webpack_public_path__ + "static/media/BusTypes_Retail_03.479dda28.png";